// Layout.jsx — sans sidebar (navigation intégrée dans le Header)
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './Header';

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-slate-50 to-slate-100 flex flex-col">
      <Header />

      <main className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          <div className="animate-in fade-in slide-in-from-top-2 duration-300">
            <Outlet />
          </div>
        </div>

        <footer className="flex-shrink-0 border-t border-slate-200 bg-white/50 backdrop-blur-sm">
          <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-center gap-2 text-xs sm:text-sm text-slate-600">
              <span className="font-semibold text-slate-900">HSE System</span>
              <span className="text-slate-400">•</span>
              <span>© {new Date().getFullYear()} Tous droits réservés</span>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}